// extracted by mini-css-extract-plugin
export default {"drawer":"chatbot-drawer_drawer__jmztQ"};